var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInvulIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.063,
    height: 21.702,
    viewBox: "0 0 19.063 21.702",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_86",
    "data-name": "Group 86",
    transform: "translate(-417.75 -116.739)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_83",
    "data-name": "Group 83",
    transform: "translate(429.445 121.858)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1095",
    "data-name": "Path 1095",
    d: "M6094.08,198.455h6.868",
    transform: "translate(-6094.08 -198.455)",
    fill: "blue",
    stroke: "#ed6f1b",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1096",
    "data-name": "Path 1096",
    d: "M6094.08,198.455h6.868",
    transform: "translate(-6094.08 -182.373)",
    fill: "blue",
    stroke: "#ed6f1b",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1097",
    "data-name": "Path 1097",
    d: "M6098.547,198.455V214.6",
    transform: "translate(-6095.113 -198.455)",
    fill: "blue",
    stroke: "#ed6f1b",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-mouse-pointer",
    "data-name": "Icon awesome-mouse-pointer",
    d: "M9.038,9.843H5.865l1.67,4.067a.556.556,0,0,1-.282.718l-1.47.641a.529.529,0,0,1-.7-.291L3.5,11.116.906,13.782A.529.529,0,0,1,0,13.4V.547A.529.529,0,0,1,.906.163L9.411,8.912A.548.548,0,0,1,9.038,9.843Z",
    transform: "translate(418 117)",
    fill: "#ed6f1b",
    stroke: "#ed6f1b",
    strokeWidth: 0.5
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvulIcon);
export default __webpack_public_path__ + "static/media/invul-icon.a512a841.svg";
export { ForwardRef as ReactComponent };